<script setup lang="ts">
import { useHead } from '@vueuse/head'
import { useI18n } from 'vue-i18n'
import { useWindowFocus } from '@vueuse/core'
import * as apis from '/@src/client-portal/api'
import { watch } from 'vue'
import { useUserSession } from '/@src/stores/userSession'
import { IDSKHeaderVariant } from '/@src/composable/componentPropsTypes'

// This is the global app setup function
const MAIN_CONTENT_ID = 'main-content'
const { t } = useI18n()
const authApi = new apis.PortalAuthApi()
const refreshToken = localStorage.getItem('refresh_token') as string
const focused = useWindowFocus()
const userSession = useUserSession()
const host = location.hostname

useHead({
  title: t('globalne.title'),
})

watch(
  () => focused.value,
  async () => {
    if (focused.value && userSession.isLoggedIn && host !== 'localhost') {
      await authApi
        .refreshTokenPortalAuth(refreshToken, {
          headers: {
            Authorization: '',
          },
        })
        .then((res) => {
          localStorage.setItem('access_token', res.data.access_token)
          localStorage.setItem('refresh_token', res.data.refresh_token)
          localStorage.setItem('id_token_hint', res?.data?.id_token)
        })
    }
  }
)
</script>
<template>
  <IDSKHeader
    :variant="
      userSession.isLoggedIn ? IDSKHeaderVariant.loggedIn : IDSKHeaderVariant.notLoggedIn
    "
  />
  <main :id="MAIN_CONTENT_ID">
    <Suspense>
      <RouterView v-slot="{ Component }">
        <Transition name="fade-slow" mode="out-in">
          <div>
            <component :is="Component" />
          </div>
        </Transition>
      </RouterView>
    </Suspense>
  </main>
  <IDSKFooter />
</template>

<style scoped lang="scss">
.blur {
  filter: blur(0.2rem);
}
</style>
